import script from "/app/apps/web/src/App.vue?type=script"
export * from "/app/apps/web/src/App.vue?type=script"
import { render } from "/app/apps/web/src/App.vue?type=template"

script.render = render
export default script